import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ApproveRefundModal = ({ isOpen, refund, onClose, onConfirm }) => {
  if (!isOpen || !refund) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden border border-border">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-success/20">
              <Icon name="CheckCircle" size={24} className="text-success" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                Approve Refund
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                Approve refund of <span className="font-semibold text-foreground">₹{refund?.refundAmount?.toLocaleString()}</span> for <span className="font-semibold text-foreground">{refund?.clientName}</span>?
              </p>
            </div>
          </div>

          <div className="p-4 bg-success/10 border border-success/20 rounded-md mb-6">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} className="text-success flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-success font-body">
                  Refund will be processed immediately
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  Reason: {refund?.reason}
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="success"
              size="lg"
              onClick={onConfirm}
              iconName="CheckCircle"
              iconPosition="left"
              fullWidth
            >
              Approve
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveRefundModal;